import FormattedMessage from 'I18n/components/FormattedMessage';
import UITag from 'UIComponents/tag/UITag';
import { jsx as _jsx } from "react/jsx-runtime";
const RE_ENROLLMENT_REASONS = ['CLASSIC_RE_ENROLL', 'EVENT_RE_ENROLL', 'PERSISTED_RE_ENROLL'];
const EnrollmentReasonTag = ({
  diagnosisResult
}) => {
  const reasonTagMessage = RE_ENROLLMENT_REASONS.includes(diagnosisResult.reasonMetadata.reason) ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.badge.reEnrolled"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.badge.enrolled"
  });
  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(UITag, {
      use: "success",
      children: reasonTagMessage
    })
  });
};
export default EnrollmentReasonTag;